// @ts-check

import React from 'react';
import Stack from '@liquidweb-dev/undercurrent/Stack';
import Box from '@liquidweb-dev/undercurrent/Box';
import Zoom from '@liquidweb-dev/undercurrent/Zoom';

/**
 * @param {Object} props
 * @param {string} props.imgUrl
 * @param {boolean} [props.animateContent]
 * @param {number} [props.transitionDelay] // transition delay in milli seconds
 */
const ImageBox = ({ imgUrl, animateContent, transitionDelay = 0 }) => {
	if (transitionDelay > 0)
		return (
			<Zoom
				in={animateContent}
				style={{
					transitionDelay: animateContent ? `${transitionDelay}ms` : '0ms',
				}}
			>
				<Box
					sx={{
						display: 'flex',
						width: 104,
						height: 104,
						justifyContent: 'center',
						alignItems: 'center',
						boxShadow: 3,
						flexShrink: 0,
						borderRadius: 104,
						backgroundImage: `url(${imgUrl})`,
						backgroundSize: 104,
					}}
				/>
			</Zoom>
		);

	return (
		<Box
			sx={{
				display: 'flex',
				width: 104,
				height: 104,
				justifyContent: 'center',
				alignItems: 'center',
				boxShadow: 3,
				flexShrink: 0,
				borderRadius: 104,
				backgroundImage: `url(${imgUrl})`,
				backgroundSize: 104,
			}}
		/>
	);
};

/**
 *
 * @param {Object} props
 * @param {boolean} [props.isAnimationRequired]
 * @param {boolean} [props.animateContent]
 * @param {import('react').ReactNode} [props.children]
 */
const CancellationModalHeader = ({
	isAnimationRequired = false,
	animateContent = false,
	children,
}) => {
	return (
		<Stack
			sx={{
				flexDirection: 'column',
				alignItems: 'center',
				gap: 300,
				alignSelf: 'stretch',
			}}
		>
			<Stack
				sx={{
					display: 'flex',
					alignItems: 'center',
					gap: -300,
					flexDirection: 'row',
				}}
			>
				<ImageBox
					imgUrl="https://www.liquidweb.com/wp-content/uploads/2025/05/my.lw-cancellation-avatar-1.png"
					transitionDelay={isAnimationRequired ? 200 : 0}
					animateContent={animateContent}
				/>
				<ImageBox
					imgUrl="https://www.liquidweb.com/wp-content/uploads/2025/05/my.lw-cancellation-avatar-2.png"
					transitionDelay={isAnimationRequired ? 400 : 0}
					animateContent={animateContent}
				/>
				<ImageBox
					imgUrl="https://www.liquidweb.com/wp-content/uploads/2025/05/my.lw-cancellation-avatar-3.png"
					transitionDelay={isAnimationRequired ? 600 : 0}
					animateContent={animateContent}
				/>
			</Stack>
			<Stack
				sx={{
					display: 'flex',
					flexDirection: 'row',
					width: '100%',
					justifyContent: 'center',
				}}
			>
				<Stack
					sx={{
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'flex-start',
						gap: 100,
						alignSelf: 'stretch',
						justifyContent: 'center',
						minWidth: 256,
						maxWidth: 600,
					}}
				>
					{children}
				</Stack>
			</Stack>
		</Stack>
	);
};

export default CancellationModalHeader;
